import React from 'react';
import { useTranslation } from 'react-i18next';

import bellmanER from '../images/horselskydd/bellmaner-687x448.png';
import bellmanChill from '../images/horselskydd/bellmanchill-687x448.png';
import bellmanSwim from '../images/horselskydd/bellmanswim-687x448.png';
import bellmanDrive from '../images/horselskydd/bellmandrive-687x448.png';
import bellmanRC from '../images/horselskydd/bellmanrc-687x448.png';
import bellmanCH from '../images/horselskydd/bellmanch-687x448.png';

const products = [
  { name: 'Bellman ER', desc: 'För musiker och konserter', image: bellmanER },
  { name: 'Bellman Chill', desc: 'För vila och sömn', image: bellmanChill },
  { name: 'Bellman Swim', desc: 'För vattensport', image: bellmanSwim },
  { name: 'Bellman Drive', desc: 'För motorsport', image: bellmanDrive },
  { name: 'Bellman RC', desc: 'För lätt industri', image: bellmanRC },
  { name: 'Bellman CH', desc: 'För arbete', image: bellmanCH },
];

const Horselskydd: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-4">{t('horselskydd.title')}</h1>
        <h2 className="text-2xl text-[#0A4A7A] mb-8">{t('horselskydd.subtitle')}</h2>
        <p className="text-gray-700 text-lg mb-4 max-w-3xl">{t('horselskydd.text1')}</p>
        <p className="text-gray-700 text-lg mb-12 max-w-3xl">{t('horselskydd.text2')}</p>

        <h3 className="text-2xl font-semibold text-[#0A4A7A] mb-8">Hitta din produkt</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {products.map((p) => (
            <div key={p.name} className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <img src={p.image} alt={p.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h4 className="font-semibold text-[#0A4A7A]">{p.name}</h4>
                <p className="text-gray-600 text-sm">{p.desc}</p>
                <p className="font-semibold text-[#0A4A7A] mt-2">2 950 kr</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#0A4A7A] rounded-lg p-8 text-center">
          <h3 className="text-2xl font-semibold mb-4 text-white">{t('horselskydd.bookTitle')}</h3>
          <p className="text-gray-200 mb-6">{t('horselskydd.bookDesc')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:072-334 47 74" className="bg-white text-[#0A4A7A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors">{t('services.call')} 072-334 47 74</a>
            <a href="https://www.bokadirekt.se/places/varmdo-horsel-134414" target="_blank" rel="noopener noreferrer" className="border border-white text-white px-6 py-3 rounded font-semibold hover:bg-white/10 transition-colors">{t('services.bookTime')}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Horselskydd;
